import { useState } from "react";
import { Link, Navigate, useNavigate } from "react-router-dom";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { api, formatApiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import AuthShell from "@/components/auth/AuthShell";

export default function Login() {
  const { user, setUser } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: "", password: "" });
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  if (user?.role === "client") return <Navigate to="/dashboard" replace />;
  if (user?.role === "admin") return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      const { data } = await api.post("/auth/login", form);
      setUser(data);
      navigate("/dashboard");
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <AuthShell eyebrow="Client portal" title="Welcome back" subtitle="Log in to view your portfolio and requests.">
      <form onSubmit={submit} className="space-y-5" data-testid="login-form">
        <div className="space-y-2">
          <Label htmlFor="login-email">Email</Label>
          <Input id="login-email" type="email" required value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className="field" data-testid="login-email-input" />
        </div>
        <div className="space-y-2">
          <Label htmlFor="login-password">Password</Label>
          <Input id="login-password" type="password" required value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} className="field" data-testid="login-password-input" />
          <div className="text-right"><Link to="/forgot-password" className="text-xs text-slate-400 hover:text-emerald-400" data-testid="login-forgot-password-link">Forgot password?</Link></div>
        </div>
        {error && <p className="rounded-xl border border-red-500/30 bg-red-500/10 px-4 py-3 text-sm text-red-400" data-testid="login-error">{error}</p>}
        <button type="submit" disabled={busy} className="btn-primary w-full" data-testid="login-submit-button">{busy ? "Logging in..." : "Log in"}</button>
        <p className="text-center text-sm text-slate-400">
          New to Meridian? <Link to="/register" className="text-emerald-400 hover:underline" data-testid="login-register-link">Open an account</Link>
        </p>
      </form>
    </AuthShell>
  );
}
